import { render, staticRenderFns } from "./PendingStatusInfo.vue?vue&type=template&id=66961309&scoped=true&"
import script from "./PendingStatusInfo.vue?vue&type=script&lang=js&"
export * from "./PendingStatusInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66961309",
  null
  
)

export default component.exports